// Regex to check valid
// GUID  
const guidRegex36 = new RegExp(/^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/);
//const guidRegex38 = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);

export default function isValidGUID(str : string): boolean {
    if (str == null)
        return false;

    // Return true if the str matched the ReGex
    return guidRegex36.test(str);
}